import React from "react";
// import founderImg from "../Assessts/Events/sir1.png";
import founderImg from "../Assessts/slideHome_images/sirimg.png";
import ourTeam from "../Assessts/team2.png";
import ourTeambelow from "../Assessts/team3.png";
import "./Founderpage.css"; // 👈 ADD THIS

const Founderpage = () => {
  return (
    <div>
      {/* Hero Section */}
      <div
        className="founder-hero"
        style={{
          position: "relative",
          width: "100%",
          height: "400px",
          overflow: "hidden",
        }}
      >
        <img
          src={ourTeam}
          alt="About Us"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            filter: "brightness(80%)",
          }}
        />
        <div
          className="founder-hero-content"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "#fff",
            textAlign: "center",
          }}
        >
          <h1
            className="founder-hero-title"
            style={{
              fontSize: "48px",
              fontWeight: "bold",
              color: "white",
            }}
          >
            Our Team
          </h1>
          <p>
            <span style={{ color: "#fff" }}>Home</span>{" "}
            <span style={{ color: "skyblue" }}>/founder</span>
          </p>
        </div>
      </div>

      {/* Founder Section */}
      <div
        className="founder-section"
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "30px",
          padding: "50px",
          flexWrap: "wrap",
        }}
      >
        <div
          className="founder-image-wrapper"
          style={{ flex: "1", textAlign: "center" }}
        >
          <img
            src={founderImg}
            alt="Founder"
            className="founder-image"
            style={{
              width: "100%",
              maxWidth: "350px",
              borderRadius: "10px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
              marginTop: "60px",
              marginLeft: "40px",
            }}
          />
        </div>

        <div
          className="founder-text"
          style={{ flex: "2", minWidth: "300px" }}
        >
          <h2
            style={{
              fontSize: "32px",
              fontWeight: "bold",
              color: "#155382ff",
            }}
          >
            About <span style={{ color: "#155382ff" }}>The Founder</span>
          </h2>

          <p
            style={{
              marginTop: "20px",
              lineHeight: "1.8",
              fontSize: "16px",
            }}
          >
            <b>Vijay Raj Tiwari</b> is the <b>Managing Director and CEO</b> of{" "}
            <b>Technocrat Aerospace and Defence Pvt. Ltd.</b>, based in Noida,
            India. where he drives advancements in
            <b>aerospace, defense, drones, and railway technologies. </b> His
            career encompasses expertise in integrating data acquisition (DAQ)
            systems, RF and microwave technologies, avionics interfaces, and
            specialized hardware essential for defense applications and
            scientific research.
          </p>

          <p
            style={{
              marginTop: "15px",
              lineHeight: "1.8",
              fontSize: "16px",
            }}
          >
            Tiwari has played a key role in corporate governance and operational
            leadership at the company, fostering innovation and
            entrepreneurship in the Indian aerospace and defense sectors. His
            contributions emphasize technological progress, as evidenced by his
            advocacy on social media platforms, where he shares insights on
            industry innovations and national advancements in these fields.
          </p>

          {/* Core Technology Areas */}
          <h3
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              marginTop: "25px",
              color: "#155382ff",
            }}
          >
            Core Technology Areas
          </h3>
          <ul
            style={{
              marginTop: "10px",
              lineHeight: "1.8",
              fontSize: "16px",
            }}
          >
            <li>
              Avionics interfaces and COTS hardware integration bridging legacy
              aerospace platforms with mission systems.
            </li>
            <li>
              RF & microwave solutions, DAQ systems, and rugged embedded
              computing for reliable operations in harsh environments.
            </li>
            <li>
              Sensors, encoders, precision switches, and certified cable
              harnesses supporting flight systems and test benches.
            </li>
          </ul>
        </div>
      </div>

      {/* Full Width Section from here */}
      <div
        className="founder-fullwidth"
        style={{
          width: "100%",
          padding: "0px 300px",
          backgroundColor: "#f9f9f9",
        }}
      >
        {/* Systems Integration Impact */}
        <h3
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            color: "#155382ff",
          }}
        >
          Systems Integration Impact
        </h3>
        <ul
          style={{
            marginTop: "15px",
            lineHeight: "1.8",
            fontSize: "16px",
          }}
        >
          <li>
            Leads turnkey integration from component design to subsystem
            qualification for aerospace and defense programs.
          </li>
          <li>
            Focuses on interoperable COTS architectures to reduce cost and lead
            time for avionics retrofits and test systems.
          </li>
          <li>
            Implements power backup and ruggedization practices to improve
            platform safety and availability.
          </li>
        </ul>

        {/* Industry Recognition */}
        <h3
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            marginTop: "40px",
            color: "#155382ff",
          }}
        >
          Industry Recognition & Outreach
        </h3>
        <ul
          style={{
            marginTop: "15px",
            lineHeight: "1.8",
            fontSize: "16px",
          }}
        >
          <li>
            Presented capabilities at <b>IREE 2025</b>, engaging with senior
            railway and defense stakeholders.
          </li>
          <li>
            Highlighted cross-domain technology transfer between defense and
            rail sectors to strengthen national infrastructure.
          </li>
          <li>
            Maintains a professional profile aligning Technocrat’s portfolio
            with India’s aerospace and defense priorities.
          </li>
        </ul>

        {/* Organizational Leadership */}
        <h3
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            marginTop: "40px",
            color: "#155382ff",
          }}
        >
          Organizational Leadership
        </h3>
        <ul
          style={{
            marginTop: "15px",
            lineHeight: "1.8",
            fontSize: "16px",
          }}
        >
          <li>
            As <b>Director/MD-CEO</b>, he has shaped Technocrat Aerospace &
            Defence Pvt. Ltd.’s technology roadmap since 2025.
          </li>
          <li>
            Oversees corporate governance, scaling operations, and compliance
            for advanced technology delivery.
          </li>
          <li>
            Promotes specialization in avionics, RF systems, and embedded
            solutions aligned with aerospace standards.
          </li>
        </ul>

        {/* Why This Matters */}
        <h3
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            marginTop: "40px",
            color: "#155382ff",
          }}
        >
          Why This Matters
        </h3>
        <ul
          style={{
            marginTop: "15px",
            lineHeight: "1.8",
            fontSize: "16px",
          }}
        >
          <li>
            Supports India’s aerospace growth through MRO, avionics
            modernization, and indigenous supply chain development.
          </li>
          <li>
            Promotes dual-use technology transfer from defense to railway and
            infrastructure sectors.
          </li>
          <li>
            Enhances Make in India goals through visible innovation and systems
            integration excellence.
          </li>
        </ul>

        {/* His Contribution */}
        <h3
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            marginTop: "40px",
            color: "#155382ff",
          }}
        >
          His Contribution
        </h3>
        <p
          style={{
            marginTop: "15px",
            lineHeight: "1.8",
            fontSize: "16px",
          }}
        >
          He has contributed to corporate governance and company operations,
          maintaining a prominent presence within the Indian aerospace and
          defense industry as both a leader and innovator. Public profiles
          highlight his advocacy for entrepreneurship and technological
          advancement—his active social media accounts display passion for
          aerospace, defense, and innovation in India.
        </p>
      </div>

      {/* Our Team Section */}
      <div
        className="founder-team-section"
        style={{ textAlign: "center", padding: "60px 20px" }}
      >
        <h2
          style={{
            fontSize: "32px",
            fontWeight: "bold",
            color: "#155382ff",
          }}
        >
          Our <span style={{ color: "#155382ff" }}>Team</span>
        </h2>

        <img
          src={ourTeambelow}
          alt="About Us"
          className="founder-team-image"
          style={{
            width: "65%",
            height: "45%",
            objectFit: "cover",
            border: "2px solid #155382ff",
            borderRadius: "8px",
            filter: "brightness(90%)",
            margin: "30px 0px",
          }}
        />

        {/* Wrap paragraphs in a left-aligned div */}
        <div
          className="founder-team-text"
          style={{ textAlign: "left", margin: "0 auto", maxWidth: "900px" }}
        >
          <p
            style={{
              lineHeight: "1.8",
              fontSize: "16px",
              marginBottom: "20px",
            }}
          >
            At Technocrat Aerospace and Defence Private Limited (TAAD), it’s our
            people who drive innovation and excellence. Our dedicated team of{" "}
            <b>engineers</b> combines deep technical expertise with sharp
            managerial skills to create solutions that go beyond expectations.
            We focus on understanding our clients’ unique challenges and
            delivering <b>real, measurable value</b> — making us a trusted
            partner in <b>Defence</b>, <b>Aerospace</b>, <b>Railways</b>, and
            the <b>Scientific Community</b>.
            <br />
            <br />
            Together, we push boundaries by developing{" "}
            <b>open, modular solutions</b> designed to meet the growing and
            complex demands of <b>data</b>, <b>communication</b>, and{" "}
            <b>sensor processing</b>. With every project, we’re shaping the
            future of technology and empowering progress.
          </p>

          <p
            style={{
              lineHeight: "1.8",
              fontSize: "16px",
            }}
          >
            At Technocrat Aerospace and Defence Private Limited, innovation
            begins with our people. Our passionate team of engineers combines
            cutting-edge technical skills with effective management to design
            solutions that truly meet our clients’ unique needs.
            <br />
            <br />
            We don’t just deliver projects — we deliver{" "}
            <b>measurable value</b> that helps our partners succeed. That’s why
            customers in <b>Defence</b>, <b>Aerospace</b>, <b>Railways</b>, and
            the <b>Scientific Community</b> rely on us as their trusted solution
            provider.
            <br />
            <br />
            By embracing <b>open, modular designs</b>, we stay ahead of the
            curve, meeting the increasing demands of complex <b>data</b>,{" "}
            <b>communication</b>, and <b>sensor technologies</b>.
            <br />
            <br />
            Join us on this journey toward shaping the{" "}
            <b>future of aerospace and defence technology</b>. Together, we’re
            not just building solutions — we’re creating the foundation for
            tomorrow’s breakthroughs.
            <br />
            <br />
            <b>
              Technocrat Aerospace and Defence Pvt. Ltd. — Engineering
              innovation, empowering progress.
            </b>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Founderpage;
